import React from 'react';
import Select from 'react-select';
import { AutocompleteProps } from './Autocomplete.types';
import { Container, HeaderStyledLabel, LabelWrapper, StyledLabel } from './Autocomplete.styles';
import { useTheme } from '@emotion/react';

const Autocomplete: React.FC<AutocompleteProps> = ({ disabled, id, options, onInputChange, onChange, label, noOptionsMessage = 'No Options', isLabelHeader = false }) => {
  const theme = useTheme();
  const customStyles = {
    dropdownIndicator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    control: (baseStyles: any, state: { isDisabled: any; }) => ({
      ...baseStyles,
      position: 'relative',
      width: '300px',
      backgroundColor: state.isDisabled ? theme.colors.gray100 : theme.colors.white,
      border: state.isDisabled ? `1px solid ${theme.colors.gray400}` : `1px solid ${theme.colors.gray600}`,
      fontFamily: 'Open Sans',
      borderRadius: '8px',
      lineHeight: '22px',
      fontWeight: '400',
    })
  }

  return (  
    <>
    <Container>
      {isLabelHeader ?
        <LabelWrapper>
          <HeaderStyledLabel htmlFor={id}>{label}</HeaderStyledLabel>
        </LabelWrapper>
        :
        <LabelWrapper>
          <StyledLabel htmlFor={id}>{label}</StyledLabel>
        </LabelWrapper>
      }
      <Select
        styles={customStyles}
        options={options}
        getOptionValue={(option) => `${option.label}`}
        isDisabled={disabled}
        id={id}
        placeholder=''
        name='number'
        onChange={onChange}
        isClearable
        onInputChange={onInputChange}
        noOptionsMessage={() => noOptionsMessage}
      />
    </Container>
    </>
  );
};

export default Autocomplete;